"use client";

import { startDetection } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Label, Select } from "@/components/ui/input";
import { useRouter } from "next/navigation";
import { useState } from "react";

export function DetectionForm({
  sites,
  targets,
}: {
  sites: { id: string; name: string }[];
  targets: { id: string; domain: string }[];
}) {
  const router = useRouter();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  return (
    <Card>
      <CardContent>
        <form
          className="grid gap-4 md:grid-cols-3"
          action={async (formData) => {
            setPending(true);
            setError("");
            try {
              const result = await startDetection(formData);
              router.push(`/detections/${result.id}`);
              router.refresh();
            } catch (err) {
              setError(err instanceof Error ? err.message : "Could not start the scan");
            } finally {
              setPending(false);
            }
          }}
        >
          <div>
            <Label>My site</Label>
            <Select name="siteId" required>
              <option value="">Choose</option>
              {sites.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </Select>
          </div>
          <div>
            <Label>Suspect</Label>
            <Select name="targetId" required>
              <option value="">Choose</option>
              {targets.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.domain}
                </option>
              ))}
            </Select>
          </div>
          <div className="flex items-end">
            <Button type="submit" disabled={pending || !sites.length}>
              {pending ? "Starting..." : "Scan and compare"}
            </Button>
          </div>
          {error ? <p className="text-sm text-[var(--danger)] md:col-span-3">{error}</p> : null}
        </form>
      </CardContent>
    </Card>
  );
}
